import { Form } from '@unform/web';
import React, { useEffect, useState } from 'react';
import { FaBell, FaCertificate, FaFile, FaIdBadge, FaImages, FaQuestionCircle, FaReceipt, FaRegIdBadge, FaSubscript, FaTicketAlt, FaTrophy, FaUser } from 'react-icons/fa';
import { FiMessageCircle } from 'react-icons/fi';

import { IconType } from 'react-icons/lib';
import { useAuth } from '../../../../hooks/Auth';
import { useConfiguration } from '../../../../hooks/Configuration';
import { useLanguage } from '../../../../hooks/Language';
import { useLoading } from '../../../../hooks/LoadingHook';
import { useModal } from '../../../../hooks/Modal';
import api from '../../../../services/api';
import { dateFullWithHour, dateLanguageDate } from '../../../../utils/date';
import format from '../../../../utils/format';
import InOut from '../../../DashboardPages/core/components/Forms/InOut';
import Sale from '../../../DashboardPages/pages/Sales';
import Agendar from './modules/Agendar';

import { Container, ContainerWhite } from './styles';
import UpdateStudent from './modules/UpdateStudent';
import UpdateStudentMulti from './modules/UploadMultiStudents';
import { useHistory } from 'react-router-dom';

interface IProps {
  changeTo: Function;

}

const Agendamentos: React.FC<IProps> = ({ changeTo = () => { } }) => {

  const { user } = useAuth();
  const history = useHistory();
  const [tickets, setTickets] = useState<Array<Record<string, any>>>([]);
  const [alunos, setAlunos] = useState<Array<Record<string, any>>>([]);

  const { addModal, removeModal } = useModal();
  const { projectHash, configuration } = useConfiguration();
  const { translate } = useLanguage();
  const { addLoading, removeLoading } = useLoading();

  const load = async () => {



    const response = await api.get(`/list-my-visitations/${projectHash}`);
    const alunosList = await api.get(`/list-visitation-student-all`);

    setAlunos(alunosList?.data?.rows)
    setTickets(response?.data?.rows || []);


  }

  useEffect(() => {



    load();


  }, [])

  const agendar = async (changeTo) => {

    addModal({ title: '', theme: 'whiteModalMini', content: <Agendar changeTo={changeTo} projectHash={projectHash} setCallback={() => load()} />, key: "agendar" })
  
  }

  const confirmDeclineVisitation = async (visitation) => {



    addLoading({ title: 'Cancelando agendamento', key: 'loading' });
    try {
      await api.put(`/decline-visitation/${visitation?._id?.toString()}/${visitation?.hour}`)

      removeModal('agendar');
      load();
      removeLoading('loading');
    }
    catch (err) {
      addModal({ title: '', theme: 'whiteModalMini', content: <p style={{ color: '#333', fontSize: '12px' }}>{err?.response?.data?.message || err?.response?.data?.error || 'Erro ao realizar agendamento'}</p> })
      removeLoading('loading');
    }


  }

  const cancelVisitation = async (visitation) => {

    addModal({ title: '', theme: 'whiteModalMini', content: <><h2 style={{ color: '#333', width: '100%', textAlign: 'center' }}>Você deseja confirmar o cancelamento da visita?</h2><button onClick={() => confirmDeclineVisitation(visitation)} className='defaultButtonMini deepPurple' style={{ padding: '10px', borderRadius: '10px', minWidth: '150px', margin: '10px auto' }} type='button'>Sim</button></>, key: "agendar" })

  }


    const openUpdate = (student) => {


  addModal({ title: '', theme: 'whiteModalMini', content: <UpdateStudent student={student} setCallback={() => load()} />, key: "atualizar-aluno" })

    
  }





  

  const openUpdateMulti = (hash) => {


  addModal({ title: '', theme: 'whiteModalMini', content: <UpdateStudentMulti hash={hash} setCallback={() => load()} />, key: "atualizar-alunos-list" })

    
  }


  return (
    <>
      <Container >

        <div className='user-block  ' style={{ overflow: 'hidden' }}>
          <div className='content-block' >


            <div className=' column' style={{ gap: '10px', marginBottom: '15px', padding: '0px', width: '100%', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
              <h1 className='yellowContent' style={{  fontSize: '18px', textAlign: 'center' }}>{translate('Agendamentos')} </h1>

              <p className='glass' style={{ maxWidth: '600px', padding: '10px', fontSize: '16px' }}>
                Venha viver a experiência do Futur.E!
Selecione o dia, horário, número de pessoas e
agende a participação do grupo.
<br/><br/>
*É necessário informar os dados de todos os
participantes. Você pode inseri-los agora,
durante a inscrição, ou posteriormente, por
meio <a href={'/arquivos/importacao.xlsx'} style={{color: '#F8E13E'}} download> desta planilha</a> <br/><br/>(faça o download,
preencha os dados e faça o upload na
plataforma).
<br/><br/>
*O responsável pode inscrever mais de uma turma, sendo até 100 participantes em cada grupo.


              </p>

              <button onClick={() => agendar(changeTo)} className=' purple'>Clique para agendar visita</button>
            </div>

            <table className='glass'><tbody>
              {tickets?.length > 0 ? <tr className='purpleBackground'><th></th><th >{translate('Data')}</th><th >{translate('Horário')}</th> <th >{translate('Nº de alunos')}</th> </tr> : <></>}
              {tickets.map(sale => {

                return <><tr key={sale._id}>
                  <td style={{ fontSize: '14px', lineHeight: '16px' }}>
                    <div className='row gap-xs'>
                    <button onClick={() => { cancelVisitation(sale) }} style={{ padding: '15px' }} className='defaultButtonMini purpleContent' type='button'>Cancelar</button>
                    
                    <button onClick={() => { openUpdateMulti(sale?.hash) }} style={{ padding: '15px' }} className='defaultButtonMini yellowContent' type='button'>Atualizar em lote</button>
                    </div>
                    </td>
 
                
                
                
                  <td style={{ fontSize: '14px', lineHeight: '16px' }}>{dateLanguageDate(sale?.date)}</td>
                  <td style={{ fontSize: '14px', lineHeight: '16px' }}>
                    {sale?.hour} </td>
                  <td style={{ fontSize: '14px', lineHeight: '16px' }}>
                    <strong>{sale?.quantity?.toString()}</strong></td>

                </tr>
                <tr key={`${sale._id}-students`}>
                  <td colSpan={4} style={{padding:'0px'}}>
                    <table className='blackTable' style={{background:'#000', width: '100%'}}>
                        <tbody>
                          <tr ><th ></th>
                          <th >Nome</th>
                          <th >Tipo de Documento</th>
                          <th >Documento</th>  
                          </tr>
                            {
                               alunos?.filter( i => i?.visitation_hash === sale?.hash)?.map( student => {

                                return <tr>
                                   <td><button className='defaultButtonMini yellowContent' onClick={() => {

                                      openUpdate(student)

                                   }}>Atualizar</button></td>
                                  <td>{student?.name || 'Aluno não cadastrado'}</td>
                                  <td>{student?.document_type || '-------------'}</td>
                                <td>{student?.rg || '-------------'}</td>
                                
                                </tr>

                               })}

                    


                        </tbody>
                    </table>



                  </td>



                </tr>

                </>


              })}


              {tickets?.length < 1 &&
                <tr  ><td colSpan={3}>{translate('Nenhuma inscrição identificada com um código da sua conta')}</td></tr>}
            </tbody>
            </table>
          </div>

        </div>
      </Container>
    </>
  );
};
export default Agendamentos;
